import { ref, snapshot } from 'valtio';
import { getAppOwnersStore } from '../../application-owners/api/applications-owners-api';
import { createGraphInfo } from '../../common/issues-trends/issues-trends-utils';
import InventoryFiltersStore from '../../dashboard-inventory/stores/inventory-filters-store';
import { calcDateRange } from '../../app/store-actions/top-bar-store-actions';
import TopBarStore from '../../app/stores/top-bar-store';
import ScanStore from '../../new-scan/store/scan-store';
import { openSnackbar } from '../../snackbar/actions/snackbar-actions';
import applicationsService from '../services';
import ApplicationsStore from '../stores/applications-store';
import {
  setApplication,
  setLastDrawerHeight,
  setLoadingSingleApp,
} from '../stores/applications-store-actions';
import { extractSingleApplication } from '../utils/application-utils';

export interface LoadSingleAppParams {
  cache: boolean;
}

export const loadSingleApplication = async (params?: LoadSingleAppParams) => {
  setLoadingSingleApp(true);
  const { selectedAppId } = snapshot(ApplicationsStore);
  const { cache = true } = params || {};
  if (selectedAppId) {
    const response = await applicationsService.getSingleApplication.execute(
      {
        applicationId: selectedAppId,
      },
      cache,
    );
    if (response && response.appOwners) {
      setApplication(extractSingleApplication(response));
    } else {
      openSnackbar('Failed to fetch application', { variant: 'error' });
    }
  }
  setLoadingSingleApp(false);
};

export const saveLastDrawerHeight = (height: number) => {
  setLastDrawerHeight(height);
};

export const loadIssuesScore = async (appNames?: string) => {
  const { filters } = snapshot(InventoryFiltersStore);
  const { displaySelectedAppOwners } = getAppOwnersStore();
  const { dateRange } = snapshot(TopBarStore);
  const [from, to] = calcDateRange(dateRange);
  const { isScanning } = snapshot(ScanStore);
  const response = await applicationsService.getIssuesScore.execute(
    {
      limit: 5,
      filters,
      owners: displaySelectedAppOwners,
      dateRange: { from, to },
      appNames: [appNames || ApplicationsStore.selectedApp?.appName],
    },
    !isScanning,
  );
  if (response) {
    ApplicationsStore.applicationIssuesScore = ref(createGraphInfo(response));
  }
};
